import { render, staticRenderFns } from "./PriceAlgorithmLogs.vue?vue&type=template&id=659f4e52&"
import script from "./PriceAlgorithmLogs.vue?vue&type=script&lang=js&"
export * from "./PriceAlgorithmLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports